import React from 'react';
import { connect } from "react-redux";
import { Route, Switch } from 'react-router-dom';
import PropTypes from "prop-types";
import { AuthenticatedRoute } from "@prominentmedia/redux-auth";
import '../styles/styles.scss';
import { updateNavOnLoggedInDetailsSuccess } from './redux/actions/loginUserDetailsActions';
import { clearErrors, usePageViews } from "@prominentmedia/coreredux";

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/LoginPage'));
const ForgottenPassword = React.lazy(() => import('./views/pages/forgottenpassword/ForgotPasswordPage'));
const ConfirmPassword = React.lazy(() => import('./views/pages/passwordconfirm/ConfirmPasswordPage'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

const App = ({clearErrors}) => {
    usePageViews(clearErrors);
        return (           
                <React.Suspense fallback={loading}>
                    <Switch>
                        <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
                        <Route exact path="/forgottenpassword" name="Forgotten Password Page" render={props => <ForgottenPassword {...props} />} />
                        <Route exact path="/Password/Confirm" name="Password Confirmation Page" render={props => <ConfirmPassword {...props} /> }/>
                        <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
                        <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
                        <AuthenticatedRoute path="/" name="Home" render={props => <TheLayout {...props} />}
                            onLoadLoggedInUserDetailsSuccessReduxAction={updateNavOnLoggedInDetailsSuccess} />
                    </Switch>
                </React.Suspense>        
        );    
}

App.propTypes = {
    clearErrors: PropTypes.func.isRequired,
    
}


function mapStateToProps() {
    return {      
    };
}

const mapDispatchToProps = {
    clearErrors   
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);